// extracted by mini-css-extract-plugin
export var deleteModal = "_sh-0";